// BuildPilot CoPilot Website - Mock Data
// All content scraped from existing buildpilot.com.au website

export const siteConfig = {
  brand: {
    name: "BuildPilot",
    tagline: "Navigate the building journey with confidence",
    subtagline: "Your one-on-one building support service in Adelaide",
    appUrl: "https://www.buildpilot.app",
    heroVideo: "/videos/hero-background.mp4"
  },
  stats: [
    { value: "30+", label: "Partner Builders" },
    { value: "25+", label: "Years Combined Experience" },
    { value: "4.5★", label: "App Reviews" },
    { value: "64,000+", label: "Community Members" }
  ]
};

export const navigation = [
  { name: "Home", href: "/" },
  { 
    name: "About", 
    href: "#",
    children: [
      { name: "Where We Fit In", href: "/where-we-fit-in" },
      { name: "Why BuildPilot", href: "/why-buildpilot" }
    ]
  },
  { 
    name: "Services", 
    href: "#",
    children: [
      { name: "Building a New Home", href: "/building-a-new-home" },
      { name: "Choosing Land", href: "/choosing-land" },
      { name: "Renovations", href: "/renovations" },
      { name: "Changing Builders", href: "/changing-builders" },
      { name: "Property Development", href: "/property-development" }
    ]
  },
  { name: "Results", href: "/results" },
  { name: "FAQs", href: "/faqs" },
  { name: "Building Tips", href: "/buildingtipsandtricks" },
  { name: "Contact", href: "/contact" }
];

export const buildingTypes = [
  {
    id: 1,
    name: "Choosing a block of land",
    icon: "/images/icons/choosing-land.avif",
    href: "/choosing-land"
  },
  {
    id: 2,
    name: "New homes",
    icon: "/images/icons/new-homes.avif",
    href: "/building-a-new-home"
  },
  {
    id: 3,
    name: "Renovations",
    icon: "/images/icons/renovations.avif",
    href: "/renovations"
  },
  {
    id: 4,
    name: "Changing builders",
    icon: "/images/icons/changing-builders.avif",
    href: "/changing-builders"
  },
  {
    id: 5,
    name: "Invest or develop",
    icon: "/images/icons/property-development.avif",
    href: "/property-development"
  },
  {
    id: 6,
    name: "Verandahs or pergolas",
    icon: "/images/icons/verandahs-pergolas.avif",
    href: "/verandahs-pergolas"
  },
  {
    id: 7,
    name: "Landscaping",
    icon: "/images/icons/landscaping.avif",
    href: "/landscaping"
  },
  {
    id: 8,
    name: "Sheds or garages",
    icon: "/images/icons/sheds-garages.avif",
    href: "/sheds-garages"
  },
  {
    id: 9,
    name: "Decking",
    icon: "/images/icons/decking.avif",
    href: "/decking"
  },
  {
    id: 10,
    name: "Interior design",
    icon: "/images/icons/interior-design.avif",
    href: "/interior-design"
  },
  {
    id: 11,
    name: "Home design",
    icon: "/images/icons/home-design.avif",
    href: "/home-design"
  },
  {
    id: 12,
    name: "Swimming pools",
    icon: "/images/icons/swimming-pools.avif",
    href: "/swimming-pools"
  }
];

export const whyBuildPilot = [
  {
    title: "Make informed decisions",
    description: "Guidance from people who genuinely understand building, renovating and improving a home - not a call centre."
  },
  {
    title: "Don't guess what your site can handle",
    description: "We help you understand your block or existing home and flag potential issues before they become expensive problems."
  },
  {
    title: "Plans tailored to you, not a template",
    description: "New build, renovation or extension - your design is shaped around your lifestyle, site and budget, never forced into a generic plan."
  },
  {
    title: "Find the right people",
    description: "We match your project with the builder, renovator, trade or pro best suited to your budget, site and expectations."
  },
  {
    title: "Save thousands",
    description: "We help pressure-test pricing so your project stays aligned with your budget, whatever you're taking on."
  },
  {
    title: "You're not left flying on your own",
    description: "Get clear guidance and support at every stage of your home project - plan, build, renovate or improve."
  }
];

export const missionContent = {
  title: "THE MISSION",
  description: "You stay in the driver's seat. We help you secure the right block of land, find the right design and builder, pressure-test cost negotiations, and avoid surprises along the way. Your building journey is ready for takeoff."
};

export const customerBuilds = [
  {
    name: "Rinaldi Residence",
    type: "Building their first home",
    location: "Magill, SA",
    image: "https://static.wixstatic.com/media/eaf73e_3dfcc24828854ae2a568f3fb62b7c16a~mv2.png"
  },
  {
    name: "Oching Residence",
    type: "Upgrading her home",
    location: "Morphett Vale, SA",
    image: "https://static.wixstatic.com/media/eaf73e_746733abbffc438da80fab190acda84a~mv2.png"
  },
  {
    name: "Shields Residence",
    type: "Subdivided property",
    location: "Semaphore, SA",
    image: "https://static.wixstatic.com/media/eaf73e_c875b3fa65ad4f24aace2e527df773b0~mv2.png"
  },
  {
    name: "Sterai Residence",
    type: "Knockdown rebuild",
    location: "Modbury, SA",
    image: "https://static.wixstatic.com/media/eaf73e_4872839fac7746feb5b86d61fbd99c3b~mv2.jpg"
  },
  {
    name: "Gray Residence",
    type: "First home buyers",
    location: "Ridgehaven, SA",
    image: "https://static.wixstatic.com/media/eaf73e_8123635876df4606bf3a148b76ba4fa9~mv2.png"
  },
  {
    name: "Leslie Residence",
    type: "First time building",
    location: "Munno Para West, SA",
    image: "https://static.wixstatic.com/media/eaf73e_568ff84462394036acff43144325b727~mv2.png"
  }
];

export const builderPartners = [
  // 2026-06-20: Homepage trusted-builders strip uses TRANSPARENT-background
  // square logos so the marquee blends cleanly into the white page
  // backdrop. Everywhere else in the platform (cards, profiles, shortlist,
  // matcher results, etc.) renders the canonical `<slug>.png` square pack
  // via `resolveBuilderLogo()` - those have solid backgrounds and look
  // better on coloured surfaces (glass cards, dark hero, etc.). Both
  // files are mirrored in the Supabase `builder-logos` bucket.
  { name: "Metricon", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/metricon-sa.png" },
  { name: "Simonds", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/simonds-homes-sa.png" },
  { name: "Fairmont Homes", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/fairmont-homes.png" },
  { name: "ABC Homes", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/australian-building-co-sa.png" },
  { name: "Rossdale Homes", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/rossdale.png" },
  { name: "Lofty Building Group", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/lofty.png" },
  { name: "Alete Homes", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/alete-homes.png" },
  { name: "Format Homes", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/format-homes.png" },
  { name: "Oakford Homes", logo: "https://customer-assets-rejwkqb3.emergentagent.net/job_eaad4cf4-b013-4778-bbae-d982e539f07c/artifacts/r34gwzv0_Oakford%20Homes%20Logo.png" },
  { name: "Orizon Homes", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/orizon-homes.png" },
  { name: "Homecorp", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/homecorp-sa.png" },
  { name: "Regent Homes", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/regent-homes.png" },
  { name: "LS Design & Construct", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/ls-design-and-construct.png" },
  { name: "Urban Edge SA", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/urban-edge-sa.png" },
  { name: "ST Construct", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/st-construct.png" },
  { name: "Urban3", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/urban3.png" },
  { name: "BuildScope", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/buildscope.png" },
  { name: "HPG", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/hpg.png" },
  { name: "Orne Renovations", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/orne-renovations.png" },
  { name: "La Vida Homes", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/la-vida-homes-sa.png" },
  { name: "Ora Projects", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/ora-projects.png" },
  { name: "AP Designer Homes", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/ap-designer-homes.png" },
  { name: "Belroc Homes", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/belroc-homes.png" },
  { name: "Bradford", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/bradford.png" },
  { name: "Incredible Homes", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/incredible-homes.png" },
  { name: "Kentbuilt", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/kentbuilt.png" },
  { name: "Scott Salisbury", logo: "https://ghkultcdfnneodcjmxpn.supabase.co/storage/v1/object/public/builder-logos/scott-salisbury.png" }
];

export const faqs = [
  {
    question: "Is BuildPilot only for new homes?",
    answer: "No. BuildPilot covers the whole home project lifecycle - planning, building, renovating, extending and improving. Whether you're comparing new-home builders, planning a renovation, adding a pool, deck or veranda, developing a block, or finishing off and moving in, we line up the right people, products and tools for the stage you're actually at. New-home building is where our content is deepest, but it's only one of the projects we help with."
  },
  {
    question: "How does BuildPilot rank builders?",
    answer: "Builders aren't ranked best-to-worst. We rank them by how closely each builder's stated preferences and capabilities fit what you've told us about your project - your build type, block, budget band, suburb and timeline. The Gold mark next to a builder means they're the closest match for your brief specifically. Change your brief and the matches change with it. We believe every builder is great at what they do; they just need the right projects that suit their business. Giving builders work they're set up for is what makes the customer experience better on both sides."
  },
  {
    question: "What's the difference between Core and Premium?",
    answer: "Core gives you the planning essentials - Cost Tracker, Checklists, Documents, Milestones, Build Progress, the Floor Plan, House & Land and Home Design matchers, Solar Orientation tool, Licence & Insurance Checker, and full access to browse listed builders and suburbs. Premium unlocks BuildPilot Intelligence (24/7 AI build coach), AI Quote Comparison, the Defects Scanner, Email Forwarding & Analysis, Find a Builder / Tradie / Supplier matchers, and the live Project Health dashboard. Cancel any time."
  },
  {
    question: "Can I compare builder quotes side-by-side?",
    answer: "Yes. AI Quote Comparison (a Premium tool) reads every quote you upload (PDF, scan, or photo), normalises line items across builders, flags hidden contingencies, and highlights gaps. You get a clean side-by-side view in under a minute, plus an auto-drafted email of the 5 most important questions to ask each builder."
  },
  {
    question: "Which states does BuildPilot cover?",
    answer: "Our deepest content is South Australia (Adelaide), with Victoria (Melbourne) now live and growing fast. The matcher, comparison tools and cost calculators work nationally, and any builder whose stated coverage includes NSW, QLD or beyond can be matched to a customer in those states. Where a tool or guide is state-specific, we say so on the page so you know what applies to you."
  },
  {
    question: "How do you verify builders?",
    answer: "We do not certify any builder's licence or insurance status on your behalf - both change too often to stand behind responsibly. Instead, BuildPilot ships two free tools: Builder Licence Check (deep links to every Australian state register) and Building Insurance Check (explains the home-warranty scheme that applies in your state and what to ask for). On every builder profile you will see a Check their licence and Check their insurance button that opens those tools with the builder's name and state pre-filled."
  },
  {
    question: "What is BuildPilot Platinum?",
    answer: "BuildPilot Platinum is your premium private dashboard that brings every BuildPilot tool together - your saved builders, cost tracker, milestones, checklists, documents, and Project Health insights all in one place, plus 24/7 building support. Sign in with your email and it remembers exactly where you left off across web and the iOS / Android apps. See current plans and pricing on the Platinum page."
  },
  {
    question: "Can I save my build brief and pick up later?",
    answer: "Yes. The moment you start a matcher we save your answers (build type, budget, suburb, bedrooms, priorities) to your anonymous brief - no signup needed. The brief auto-fills every form on the site, ranks home designs and suburbs by % match to what you said you want, and syncs to your CoPilot the moment you sign in. Tell us once, never re-enter it."
  },
  {
    question: "Can I choose my own builder?",
    answer: "Absolutely. The matcher and rankings are guidance, not a gate. If you've got a builder in mind, search for them in our directory, save them to your shortlist, request quotes, and run their offer through Quote Comparison alongside any of our matched picks. Your decision, always."
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Guide you through the journey",
    description: "We walk by your side through the maze of construction, armed with a treasure trove of insights.",
    points: [
      "Our team boasts a combined 23 years in the building industry",
      "We liaise primarily with building owners and managers",
      "Demystifying complex jargon is our forte",
      "Our technology gives us instant answers"
    ]
  },
  {
    step: 2,
    title: "Finding a builder",
    description: "We will act like your compass in finding the builder that suits you best on this adventure.",
    points: [
      "We unravel distinct builder categories and match them to your needs",
      "Unearth what matters most: clear communication, openness, or accurate pricing",
      "We're in sync with builders' ongoing projects",
      "Past project insights directly impact your project's financial plan"
    ]
  },
  {
    step: 3,
    title: "Win back control",
    description: "With our experience, you step into the driver's seat and take control of your home build budget.",
    points: [
      "We work with you to design homes that optimise liveability",
      "Solar orientation guides our designs, creating bright enjoyable homes",
      "Together we look at your land's unique characteristics",
      "Your home becomes an oasis you'll want to stay in"
    ]
  }
];

export const testimonials = [
  {
    quote: "Helped us understand what to look out for when we were searching for a block, they would have saved us thousands of dollars in mistakes if we didn't use them.",
    author: "Johana and Josh Gray",
    location: "Ridgehaven, South Australia"
  }
];

export const socialLinks = [
  { name: "Instagram", href: "https://instagram.com/buildpilot.com.au" },
  { name: "Facebook", href: "https://www.facebook.com/buildpilot.com.au" },
  { name: "LinkedIn", href: "https://www.linkedin.com/company/buildpilotau/" },
  { name: "TikTok", href: "https://www.tiktok.com/@buildpilot.com.au" }
];

export const footerLinks = {
  services: [
    { name: "Building a New Home", href: "/building-a-new-home" },
    { name: "Choosing Land", href: "/choosing-land" },
    { name: "Renovations", href: "/renovations" },
    { name: "Changing Builders", href: "/changing-builders" },
    { name: "Property Development", href: "/property-development" }
  ],
  company: [
    { name: "Where We Fit In", href: "/where-we-fit-in" },
    { name: "Why BuildPilot", href: "/why-buildpilot" },
    { name: "Our Results", href: "/results" },
    { name: "Building Tips", href: "/buildingtipsandtricks" }
  ],
  support: [
    { name: "FAQs", href: "/faqs" },
    { name: "Contact Us", href: "/contact" },
    { name: "Privacy Policy", href: "/privacy" },
    { name: "Terms & Conditions", href: "/terms" }
  ]
};

// Building Types - Detailed Page Content
export const buildingTypePages = {
  "choosing-land": {
    slug: "choosing-land",
    title: "Choosing a Block of Land",
    subtitle: "Find the perfect foundation for your dream home",
    heroImage: "/images/heroes/choosing land.webp",
    icon: "/images/icons/choosing-land.avif",
    intro: "Selecting the right block of land is one of the most critical decisions in your building journey. The wrong choice can cost you tens of thousands in unexpected site costs, limit your design options, or leave you with a home that doesn't suit your lifestyle.",
    benefits: [
      {
        title: "Understand Site Costs Upfront",
        description: "We help you understand potential issues like slope, soil type, easements, and services that could affect your budget before you commit."
      },
      {
        title: "Maximise Your Design Options",
        description: "Understanding your block's orientation, dimensions, and restrictions helps us check whether your dream design is achievable on that block."
      },
      {
        title: "Make Confident Decisions",
        description: "Stop second-guessing. With expert analysis, you'll know exactly what you're buying and what it means for your build."
      },
      {
        title: "Save Time & Stress",
        description: "We handle the technical assessments so you can focus on finding the right location and lifestyle fit."
      }
    ],
    process: [
      { step: 1, title: "Block Assessment", description: "We walk you through your shortlisted blocks, looking at orientation, slope, services, and potential cost factors." },
      { step: 2, title: "Feasibility Report", description: "Receive a detailed report on each block's building potential and estimated site costs." },
      { step: 3, title: "Design Compatibility", description: "We help you understand how your preferred home designs may work on each block." },
      { step: 4, title: "Decision Support", description: "Get clear, unbiased advice to help you make the best choice for your budget and lifestyle." }
    ],
    faqs: [
      { question: "How much do site costs typically add to a build?", answer: "Site costs in Adelaide can range from $15,000 to $80,000+ depending on the block. Factors include slope, soil type, rock, tree removal, retaining walls, and service connections. We help you understand these costs before you buy." },
      { question: "What should I look for when viewing a block?", answer: "Key factors include orientation (north-facing living areas are ideal), slope (flat is cheaper to build on), easements, covenants, nearby development, flood zones, and existing trees. We provide a comprehensive checklist and can assess blocks on your behalf." },
      { question: "Can you help with land and house packages?", answer: "Absolutely. We can review land and house packages to check the design suits the block and the pricing is fair. Often, packages can be modified to better suit your needs." }
    ],
    cta: {
      title: "Ready to Find Your Perfect Block?",
      description: "Don't risk costly mistakes. Get guidance on your land selection.",
      buttonText: "Get Land Assessment"
    },
    relatedTypes: ["building-a-new-home", "property-development", "home-design"]
  },
  "building-a-new-home": {
    slug: "building-a-new-home",
    title: "Building a New Home",
    subtitle: "Your guide to a stress-free new home build",
    heroImage: "/images/heroes/new homes.webp",
    icon: "/images/icons/new-homes.avif",
    intro: "Building a new home should be exciting, not overwhelming. Whether you're a first-time builder or upgrading your family home, we provide the guidance you need to get through the process with confidence.",
    benefits: [
      {
        title: "Find the Right Builder",
        description: "We match you with builders suited to your budget, block, and build type-not just whoever's offering the biggest discount."
      },
      {
        title: "Understand True Costs",
        description: "No more surprises. We help you understand inclusions, exclusions, and the real cost of your build before signing."
      },
      {
        title: "Optimised Design",
        description: "We help your design maximise liveability, energy efficiency, and suits your block's unique characteristics."
      },
      {
        title: "Client Advocacy",
        description: "We work for you, not the builder. Get honest, unbiased advice throughout your entire building journey."
      }
    ],
    process: [
      { step: 1, title: "Initial Consultation", description: "We learn about your goals, budget, block, and preferences to create a tailored approach." },
      { step: 2, title: "Builder Matching", description: "We connect you with builders suited to your project type, budget, and location." },
      { step: 3, title: "Design Review", description: "We walk you through quotes and designs, highlighting differences and helping to make sure nothing is missed." },
      { step: 4, title: "Ongoing Support", description: "From contract to completion, we're here to answer questions and advocate on your behalf." }
    ],
    faqs: [
      { question: "How do I choose between project builders and custom builders?", answer: "Project builders offer cost-effective solutions with proven designs, ideal for standard blocks. Custom builders provide more flexibility for unique designs or challenging sites. We help you determine which approach suits your needs and budget." },
      { question: "What's included in a builder's quote?", answer: "Quotes vary significantly. We walk you through inclusions like flooring, kitchen fittings, electrical points, landscaping, driveways, and site costs so you are comparing apples with apples." },
      { question: "How long does a new home build take?", answer: "Build times vary, but many projects take around 6-12 months from slab to handover depending on size, complexity, and builder workload. We help set realistic expectations and monitor progress." }
    ],
    cta: {
      title: "Ready to Start Building?",
      description: "Get guidance from land selection to keys in hand.",
      buttonText: "Start Your Journey"
    },
    relatedTypes: ["choosing-land", "home-design", "interior-design"]
  },
  "renovations": {
    slug: "renovations",
    title: "Renovations",
    subtitle: "Transform your existing home with confidence",
    heroImage: "/images/heroes/renovations.webp",
    icon: "/images/icons/renovations.avif",
    intro: "Renovating can breathe new life into your home, but it comes with unique challenges. From structural considerations to living through construction, we help you work through the complexities of renovation projects.",
    benefits: [
      {
        title: "Realistic Budgeting",
        description: "Renovations often uncover surprises. We help you plan for contingencies and understand true costs upfront."
      },
      {
        title: "Right Tradies & Builders",
        description: "Not all builders do renovations well. We connect you with professionals experienced in reno-specific challenges."
      },
      {
        title: "Design Integration",
        description: "We help new work blend seamlessly with existing structures while meeting current building codes."
      },
      {
        title: "Minimise Disruption",
        description: "Strategic planning helps reduce the impact on your daily life during construction."
      }
    ],
    process: [
      { step: 1, title: "Scope Definition", description: "We help clarify what you want to achieve and identify potential structural or compliance issues." },
      { step: 2, title: "Budget Planning", description: "Develop a realistic budget including contingency for unexpected discoveries." },
      { step: 3, title: "Builder Selection", description: "We connect you with renovation-experienced builders suited to your project's scale and complexity." },
      { step: 4, title: "Project Oversight", description: "Ongoing support to help keep work on track and meets your expectations." }
    ],
    faqs: [
      { question: "Should I renovate or knock down and rebuild?", answer: "This depends on your home's condition, heritage status, the extent of changes needed, and budget. We can help you compare both options to make the best decision." },
      { question: "Do I need council approval for renovations?", answer: "Most structural changes, extensions, and additions require development approval. Even internal changes may need approval if they affect load-bearing walls or compliance. We help you understand the requirements." },
      { question: "How do I budget for unexpected issues?", answer: "A 10-20% contingency is commonly suggested for renovations. Older homes often have surprises behind walls-outdated wiring, asbestos, termite damage, or structural issues. Proper planning reduces risk." }
    ],
    cta: {
      title: "Planning a Renovation?",
      description: "Get guidance before you start tearing down walls.",
      buttonText: "Get Renovation Guidance"
    },
    relatedTypes: ["interior-design", "decking", "verandahs-pergolas"]
  },
  "changing-builders": {
    slug: "changing-builders",
    title: "Changing Builders",
    subtitle: "Get through mid-project builder changes with expert support",
    heroImage: "/images/heroes/changing builders.webp",
    icon: "/images/icons/changing-builders.avif",
    intro: "Sometimes things don't work out with your builder. Whether due to poor communication, quality issues, or company collapse, changing builders mid-project is complex but manageable with the right guidance.",
    benefits: [
      {
        title: "Understand Your Options",
        description: "We help you assess whether to persist, negotiate, or make a change-and what each path involves."
      },
      {
        title: "Protect Your Investment",
        description: "Understand common contract terms, review your agreement carefully, and protect the money you've already spent."
      },
      {
        title: "Find a Completion Builder",
        description: "Not all builders take over incomplete projects. We connect you with those who specialise in completion work."
      },
      {
        title: "Document Everything",
        description: "We help you document the current state of work for handover and potential disputes."
      }
    ],
    process: [
      { step: 1, title: "Situation Assessment", description: "We look at your contract, current progress, and the issues you're facing." },
      { step: 2, title: "Options Analysis", description: "Understand your choices: resolution, termination, or transition to a new builder." },
      { step: 3, title: "Builder Search", description: "If changing, we find completion builders willing and able to take over." },
      { step: 4, title: "Transition Support", description: "We help manage the handover process and protect your interests." }
    ],
    faqs: [
      { question: "What happens if my builder goes bankrupt?", answer: "You may be able to claim on their insurance (domestic building insurance is mandatory in SA for contracts over $12,000). We can help you understand your coverage and next steps." },
      { question: "Can I terminate my building contract?", answer: "Building contracts have specific termination clauses, and the process depends on your contract type and circumstances. Early termination without valid grounds can result in penalties. Independent legal advice is recommended to understand the options and potential costs for your specific situation." },
      { question: "Will another builder take over my half-finished home?", answer: "Some builders specialise in completion work, but they'll need to assess the existing work's quality and compliance. This usually involves additional costs for remediation and new documentation." }
    ],
    cta: {
      title: "Facing Builder Issues?",
      description: "Don't go through this alone. Get expert support today.",
      buttonText: "Get Help Now"
    },
    relatedTypes: ["building-a-new-home", "renovations"]
  },
  "property-development": {
    slug: "property-development",
    title: "Property Development",
    subtitle: "Feasibility analysis and development guidance",
    heroImage: "/images/heroes/invest or develop.webp",
    icon: "/images/icons/property-development.avif",
    intro: "Whether you're subdividing your backyard or developing multiple dwellings, property development requires careful feasibility analysis. We help you understand the numbers and work through the process.",
    benefits: [
      {
        title: "Feasibility Analysis",
        description: "Before you invest, know whether your development will actually be profitable with realistic cost and return projections."
      },
      {
        title: "Council & Planning",
        description: "Understand zoning, setbacks, and development requirements that will shape what you can build."
      },
      {
        title: "Builder & Team Selection",
        description: "Connect with builders and professionals experienced in development projects."
      },
      {
        title: "Risk Management",
        description: "Identify and plan for risks before they become expensive problems."
      }
    ],
    process: [
      { step: 1, title: "Site Assessment", description: "We help you understand your site's development potential, zoning, and constraints." },
      { step: 2, title: "Feasibility Study", description: "Detailed financial analysis including construction costs, timelines, and projected returns." },
      { step: 3, title: "Planning Strategy", description: "Work through council requirements and develop an approval strategy." },
      { step: 4, title: "Execution Support", description: "Ongoing guidance through design, approvals, and construction phases." }
    ],
    faqs: [
      { question: "What's the minimum block size for subdivision in Adelaide?", answer: "This depends on your council's development plan and zoning. Some areas allow small lot subdivision (under 300sqm), while others require larger minimums. We can assess your specific site's potential." },
      { question: "How long does development approval take?", answer: "Simple subdivisions may take 3-6 months, while more complex developments can take 12+ months. Early engagement with council and quality applications speed up the process." },
      { question: "Should I develop or sell to a developer?", answer: "This depends on your risk tolerance, capital, and time. Developing yourself typically offers higher returns but requires more involvement and carries more risk. We can help you analyse both options." }
    ],
    cta: {
      title: "Considering Development?",
      description: "Get a professional feasibility assessment before you commit.",
      buttonText: "Request Feasibility Analysis"
    },
    relatedTypes: ["choosing-land", "building-a-new-home"]
  },
  "knockdown-rebuild": {
    slug: "knockdown-rebuild",
    title: "Knockdown Rebuild",
    subtitle: "Replace your old home without leaving your location",
    heroImage: "/images/heroes/knockdown rebuild.webp",
    icon: "/images/icons/property-development.avif",
    intro: "Love your location but not your home? A knockdown rebuild lets you start fresh on your existing block, avoiding stamp duty while creating a modern, energy-efficient home tailored to your lifestyle.",
    benefits: [
      {
        title: "Keep Your Location",
        description: "Stay in the neighbourhood you love - near your favourite schools, shops, and community - while upgrading to a brand new home."
      },
      {
        title: "Potential Stamp Duty Savings",
        description: "Building on land you already own may mean you don't pay stamp duty on the construction cost - potential savings that could go towards your new home. Speak with your conveyancer or accountant about how this applies to your situation."
      },
      {
        title: "Modern & Efficient",
        description: "New builds meet current 7-star energy ratings by default, delivering lower running costs and better comfort year-round."
      },
      {
        title: "Complete Customisation",
        description: "Design every room to suit how you live today - no compromises, no working around old layouts or structural limitations."
      }
    ],
    process: [
      { step: 1, title: "Site Assessment", description: "We look at your block for demolition requirements, council rules, and build potential." },
      { step: 2, title: "Design Planning", description: "Work with us to design a home that maximises your block and suits your lifestyle." },
      { step: 3, title: "Builder Selection", description: "We help you find builders experienced in knockdown rebuilds and complex sites." },
      { step: 4, title: "Approvals & Demolition", description: "Work through council approvals and coordinate safe demolition of your existing home." },
      { step: 5, title: "Construction Support", description: "Ongoing guidance through your build with inspections and progress monitoring." }
    ],
    faqs: [
      { question: "Is a knockdown rebuild cheaper than renovating?", answer: "Often yes. Major renovations can uncover costly surprises behind walls - asbestos, outdated wiring, structural issues. A new build has fixed pricing, no hidden costs, and meets modern standards without expensive retrofitting." },
      { question: "How long does a knockdown rebuild take?", answer: "Timeframes vary, but many knockdown rebuilds take around 12-18 months from decision to move-in, including design, approvals, demolition, and construction. Complex sites or custom designs may take longer." },
      { question: "Do I need to move out during construction?", answer: "Yes, you'll need alternative accommodation during demolition and construction - timelines vary but this is often around 8-12 months depending on the build. We can help you plan the timing." },
      { question: "What happens to my landscaping and fencing?", answer: "Most existing landscaping will be removed during demolition. Some mature trees may be protected by council regulations - we look at this during the feasibility stage." }
    ],
    cta: {
      title: "Considering a Knockdown Rebuild?",
      description: "Let us assess your block and help you understand what's possible.",
      buttonText: "Request Site Assessment"
    },
    relatedTypes: ["building-a-new-home", "renovations", "choosing-land"]
  },
  "verandahs-pergolas": {
    slug: "verandahs-pergolas",
    title: "Verandahs & Pergolas",
    subtitle: "Extend your living space outdoors",
    heroImage: "/images/heroes/verandahs and pergolas.webp",
    icon: "/images/icons/verandahs-pergolas.avif",
    intro: "A well-designed verandah or pergola extends your living space and adds value to your home. We help you choose the right design, materials, and builder for your outdoor addition.",
    benefits: [
      {
        title: "Design Options",
        description: "From flat roof to gable, timber to steel-we help you choose the right style for your home and budget."
      },
      {
        title: "Council Compliance",
        description: "Understand what approvals you need and how to meet setback and coverage requirements."
      },
      {
        title: "Quality Installation",
        description: "Connect with experienced outdoor builders who deliver quality workmanship."
      },
      {
        title: "Fair Pricing",
        description: "Understand what's reasonable to pay and avoid overpriced quotes."
      }
    ],
    process: [
      { step: 1, title: "Design Consultation", description: "We discuss your needs, preferences, and site considerations." },
      { step: 2, title: "Compliance Check", description: "Determine council requirements and any restrictions on your property." },
      { step: 3, title: "Quote Review", description: "We help you understand and compare quotes from outdoor builders." },
      { step: 4, title: "Build Support", description: "Guidance through the construction process." }
    ],
    faqs: [
      { question: "Do I need council approval for a verandah?", answer: "Most verandahs and pergolas over a certain size need approval. Factors include size, setback from boundaries, and site coverage. We can help you determine your requirements." },
      { question: "What's the difference between a verandah and a pergola?", answer: "Verandahs have solid roofing attached to the house, providing full weather protection. Pergolas have open or slatted roofing, offering partial shade. Both can be enclosed or open-sided." },
      { question: "How much does a verandah cost?", answer: "Costs vary from $5,000 for basic flat roof designs to $30,000+ for large gable verandahs. We help you understand what drives costs and get fair quotes." }
    ],
    cta: {
      title: "Planning an Outdoor Addition?",
      description: "Get guidance on your verandah or pergola project.",
      buttonText: "Get Outdoor Guidance"
    },
    relatedTypes: ["decking", "landscaping", "renovations"]
  },
  "landscaping": {
    slug: "landscaping",
    title: "Landscaping",
    subtitle: "Create beautiful outdoor spaces",
    heroImage: "/images/heroes/landscaping.webp",
    icon: "/images/icons/landscaping.avif",
    intro: "Great landscaping transforms your property and adds significant value. Whether you're starting from scratch or refreshing an existing garden, we help you plan and execute beautiful outdoor spaces.",
    benefits: [
      {
        title: "Cohesive Design",
        description: "We help create a landscape plan that complements your home and suits Adelaide's climate."
      },
      {
        title: "Budget Management",
        description: "Landscaping can quickly blow budgets. We help you prioritise and stage work effectively."
      },
      {
        title: "Quality Landscapers",
        description: "Connect with experienced landscapers who are focused on quality outcomes."
      },
      {
        title: "Low Maintenance Options",
        description: "Design choices that look great without requiring constant upkeep."
      }
    ],
    process: [
      { step: 1, title: "Site Analysis", description: "We look at your outdoor space, soil, drainage, and orientation." },
      { step: 2, title: "Design Direction", description: "Develop a concept that suits your lifestyle, budget, and maintenance preferences." },
      { step: 3, title: "Landscaper Selection", description: "We connect you with qualified landscapers suited to your project." },
      { step: 4, title: "Project Management", description: "Support through installation to support quality outcomes." }
    ],
    faqs: [
      { question: "When should I landscape after building?", answer: "Allow time for the site to settle after construction (typically 3-6 months). Some choose to do basic work immediately for usability, then detailed landscaping later." },
      { question: "How much should I budget for landscaping?", answer: "A general guide is 10-15% of your home's value for comprehensive landscaping. However, this varies greatly based on scope. We help you set realistic expectations." },
      { question: "Can landscaping be staged?", answer: "Absolutely. Many homeowners find it helpful to stage-starting with hardscape (paving, retaining walls) and essential plants, then adding features over time as budget allows." }
    ],
    cta: {
      title: "Ready to Transform Your Outdoors?",
      description: "Get guidance on your landscaping project.",
      buttonText: "Get Landscaping Help"
    },
    relatedTypes: ["decking", "swimming-pools", "verandahs-pergolas"]
  },
  "sheds-garages": {
    slug: "sheds-garages",
    title: "Sheds & Garages",
    subtitle: "Quality storage and workshop solutions",
    heroImage: "/images/heroes/shed or garages.webp",
    icon: "/images/icons/sheds-garages.avif",
    intro: "From basic garden sheds to large garages and workshops, we help you plan the right structure for your needs while navigating council requirements and finding quality builders.",
    benefits: [
      {
        title: "Right Size & Design",
        description: "We help you choose the right size, style, and features for your needs and property."
      },
      {
        title: "Council Compliance",
        description: "Understand approval requirements, setbacks, and height limits before you order."
      },
      {
        title: "Quality Materials",
        description: "Sort through the range of materials and quality levels to get the best value."
      },
      {
        title: "Professional Installation",
        description: "Connect with experienced installers for quality results."
      }
    ],
    process: [
      { step: 1, title: "Needs Assessment", description: "We discuss your storage, workshop, or parking requirements." },
      { step: 2, title: "Site & Compliance", description: "Check council requirements and optimal positioning on your property." },
      { step: 3, title: "Quote Comparison", description: "We help you compare options from shed companies and builders." },
      { step: 4, title: "Installation Support", description: "Guidance through the installation process." }
    ],
    faqs: [
      { question: "Do I need approval for a shed?", answer: "Sheds under 15sqm in SA may not need approval, but there are restrictions on placement and total site coverage. Larger structures typically need development approval. We can clarify your requirements." },
      { question: "Colorbond or timber frame?", answer: "Colorbond steel is popular for its durability and low maintenance. Timber frames can offer a more traditional look but require more upkeep. We help you choose based on your priorities." },
      { question: "Can I build a shed with a concrete slab?", answer: "Concrete slabs are recommended for garages and workshops. They add cost but provide a stable, clean surface. We can advise on slab requirements for your intended use." }
    ],
    cta: {
      title: "Planning a Shed or Garage?",
      description: "Get guidance on your outdoor structure project.",
      buttonText: "Get Shed Guidance"
    },
    relatedTypes: ["verandahs-pergolas", "landscaping"]
  },
  "decking": {
    slug: "decking",
    title: "Decking",
    subtitle: "Beautiful timber and composite decks",
    heroImage: "/images/heroes/decking.webp",
    icon: "/images/icons/decking.avif",
    intro: "A quality deck extends your living space and creates a seamless connection between indoors and out. We help you choose the right materials, design, and builder for your deck project.",
    benefits: [
      {
        title: "Material Selection",
        description: "Timber, composite, or hybrid-we help you understand the pros, cons, and costs of each option."
      },
      {
        title: "Design Optimisation",
        description: "Deck design that maximises your space and complements your home's architecture."
      },
      {
        title: "Quality Builders",
        description: "Connect with experienced deck builders who deliver quality workmanship."
      },
      {
        title: "Longevity Planning",
        description: "Design and material choices designed to help your deck look great for years to come."
      }
    ],
    process: [
      { step: 1, title: "Design Consultation", description: "We discuss your vision, usage needs, and preferences." },
      { step: 2, title: "Material Selection", description: "Compare timber species, composites, and other options." },
      { step: 3, title: "Builder Matching", description: "We connect you with experienced deck specialists for your project." },
      { step: 4, title: "Build Oversight", description: "Support through construction for quality results." }
    ],
    faqs: [
      { question: "Timber or composite decking?", answer: "Timber offers natural beauty but requires regular maintenance (oiling, sealing). Composite is low-maintenance but costs more upfront. We help you weigh the long-term costs and benefits." },
      { question: "What timber is best for decking in Adelaide?", answer: "Merbau and Spotted Gum are popular for their durability and appearance. Treated pine is budget-friendly but requires more maintenance. We can help you weigh up the options based on your priorities." },
      { question: "How long does a deck last?", answer: "Well-built timber decks can last 15-25+ years with proper maintenance. Composite decks often come with 20-25 year warranties. The subframe is critical-hardwood or steel frames last longest." }
    ],
    cta: {
      title: "Ready for a New Deck?",
      description: "Get guidance on your decking project.",
      buttonText: "Get Decking Help"
    },
    relatedTypes: ["verandahs-pergolas", "landscaping", "renovations"]
  },
  "interior-design": {
    slug: "interior-design",
    title: "Interior Design",
    subtitle: "Create beautiful, functional interiors",
    heroImage: "/images/heroes/interior design.webp",
    icon: "/images/icons/interior-design.avif",
    intro: "Great interior design makes your home more liveable and valuable. Whether you're building new or renovating, we help you make smart selections for colours, materials, fixtures, and finishes.",
    benefits: [
      {
        title: "Cohesive Vision",
        description: "We help create a design direction that ties your home together beautifully."
      },
      {
        title: "Smart Selections",
        description: "Work through the overwhelming world of builder selections with confidence."
      },
      {
        title: "Budget Optimisation",
        description: "Know where to splurge and where to save for maximum impact."
      },
      {
        title: "Trend Awareness",
        description: "Balance current trends with timeless choices that won't date quickly."
      }
    ],
    process: [
      { step: 1, title: "Style Discovery", description: "We explore your preferences, lifestyle, and design inspirations." },
      { step: 2, title: "Selection Strategy", description: "Develop a plan for colours, materials, and fixtures that work together." },
      { step: 3, title: "Supplier Guidance", description: "Work through builder selections and independent suppliers." },
      { step: 4, title: "Review Support", description: "We help you review choices before final commitment." }
    ],
    faqs: [
      { question: "Should I use my builder's selections or source my own?", answer: "Builder selections can be convenient but may be limited or overpriced. We help you understand when to use theirs and when to source independently for better quality or value." },
      { question: "How do I choose a colour scheme?", answer: "A common approach is starting with a 'hero' element you love (artwork, fabric, feature tile) and building your palette from there. Neutral bases with accent colours offer flexibility." },
      { question: "What's worth spending more on?", answer: "Kitchen, bathrooms, and flooring have the biggest impact on daily life and resale value. We help you prioritise where to invest for maximum return." }
    ],
    cta: {
      title: "Need Interior Design Help?",
      description: "Get guidance on your selections and finishes.",
      buttonText: "Get Design Guidance"
    },
    relatedTypes: ["building-a-new-home", "renovations", "home-design"]
  },
  "home-design": {
    slug: "home-design",
    title: "Home Design",
    subtitle: "Floor plans that work for your life",
    heroImage: "/images/heroes/home design.webp",
    icon: "/images/icons/home-design.avif",
    intro: "Your home's design determines how you'll live in it for years to come. We help you evaluate floor plans, optimise layouts, and check your design suits your block, budget, and lifestyle.",
    benefits: [
      {
        title: "Lifestyle Fit",
        description: "We help check your floor plan works for how you actually live-now and into the future."
      },
      {
        title: "Site Optimisation",
        description: "Design that makes the most of your block's orientation, views, and characteristics."
      },
      {
        title: "Energy Efficiency",
        description: "Smart design reduces ongoing energy costs and improves comfort."
      },
      {
        title: "Future-Proofing",
        description: "Consider future needs like ageing in place, family changes, or resale."
      }
    ],
    process: [
      { step: 1, title: "Needs Analysis", description: "We explore your lifestyle, family needs, and future considerations." },
      { step: 2, title: "Design Review", description: "Analyse floor plans for functionality, flow, and efficiency." },
      { step: 3, title: "Site Matching", description: "Check your design works well on your specific block." },
      { step: 4, title: "Modification Support", description: "Help negotiate design changes with builders or designers." }
    ],
    faqs: [
      { question: "Project home plan or custom design?", answer: "Project plans are cost-effective and proven, but may need modifications. Custom designs offer complete flexibility but cost more. We help you decide based on your needs and budget." },
      { question: "What makes a good floor plan?", answer: "Key factors include traffic flow, separation of living zones, natural light, storage, and room proportions. We look at plans against these criteria for your specific needs." },
      { question: "How important is orientation?", answer: "Critical for energy efficiency and comfort. North-facing living areas maximise winter sun while minimising summer heat. We look at orientation and suggest design adjustments." }
    ],
    cta: {
      title: "Need Help with Your Home Design?",
      description: "Get expert analysis of your floor plans and design options.",
      buttonText: "Get Design Review"
    },
    relatedTypes: ["building-a-new-home", "choosing-land", "interior-design"]
  },
  "swimming-pools": {
    slug: "swimming-pools",
    title: "Swimming Pools",
    subtitle: "Your guide to pool installation",
    heroImage: "/images/heroes/pools.webp",
    icon: "/images/icons/swimming-pools.avif",
    intro: "A swimming pool is a significant investment that can transform your lifestyle and property value. We help you work through pool types, builders, and the complex approval process.",
    benefits: [
      {
        title: "Pool Type Guidance",
        description: "Concrete, fibreglass, or above-ground-we help you choose the right pool for your needs and budget."
      },
      {
        title: "Site Assessment",
        description: "Understand access requirements, soil conditions, and placement options for your property."
      },
      {
        title: "Builder Selection",
        description: "Connect with reputable pool builders in our network."
      },
      {
        title: "Compliance Support",
        description: "Work through council approvals and fencing requirements."
      }
    ],
    process: [
      { step: 1, title: "Needs Assessment", description: "We discuss your usage, preferences, and budget parameters." },
      { step: 2, title: "Site Evaluation", description: "Assess your property for pool placement, access, and potential issues." },
      { step: 3, title: "Builder Matching", description: "We connect you with pool builders suited to your project type and budget." },
      { step: 4, title: "Process Support", description: "Guidance through approvals, construction, and compliance." }
    ],
    faqs: [
      { question: "Fibreglass or concrete pool?", answer: "Fibreglass pools are faster to install and lower maintenance, with many shape options. Concrete pools offer complete customisation but cost more and take longer. We help you weigh the options." },
      { question: "How much does a pool cost?", answer: "Fibreglass pools typically range from $35,000-$70,000 installed. Concrete pools start around $50,000 and can exceed $100,000 for larger designs. Site conditions significantly impact final costs." },
      { question: "What ongoing costs should I expect?", answer: "Budget $1,500-$3,000 annually for chemicals, energy, and basic maintenance. Concrete pools may require resurfacing every 10-15 years. We help you understand total cost of ownership." }
    ],
    cta: {
      title: "Dreaming of a Pool?",
      description: "Get guidance on your pool project.",
      buttonText: "Get Pool Guidance"
    },
    relatedTypes: ["landscaping", "decking", "verandahs-pergolas"]
  }
};